import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Drawer, Backdrop } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { subHours, getUnixTime } from 'date-fns';

import Button from 'src/components/Button/Button';
import './RangeFilterButtons.scss';
import useIsMobile from '../../../hooks/useIsMobile';
import RangePicker from 'src/components/RangePicker/RangePicker';
import classNames from 'classnames';
import Icon from 'src/components/Icon/Icon';
import DropdownTypeList from '../Dropdown/DropdownTypeList';
import { RootState } from 'src/configs/store';

interface RangeFilterButtonsProps {
  showRange?: boolean,
  onRangeApply?: Function,
  onRangeClear?: () => void,
  dateChanges?: Function
  filterButtons: {
    label: string,
    value: number,
  }[],
  dateRange?: {
    startDate: Date,
    endDate: Date,
    key: string
  }[],
  selectedButton: number,
  // eslint-disable-next-line no-unused-vars
  onButtonClick: (e) => void,
  type?: object,
  setType?: any,
  hours?: number,
  sort?: string,
  setSort?: Function
}

function RangeFilterButtons({
  filterButtons,
  onButtonClick,
  onRangeApply,
  dateRange,
  dateChanges,
  selectedButton,
  onRangeClear,
  type,
  setType,
  hours,
  sort,
  setSort
}: RangeFilterButtonsProps) {
  const [openRange, setOpenRange] = useState(false);
  const { customer }  = useSelector((state: RootState) => state.auth);
  const { customerTransactionTypeList } = useSelector((state:RootState) => state.account);
  const activeWallet = _.find(customer.wallets, { isActive: true });

  const dispatch = useDispatch();

  const { t } = useTranslation();
  const mobile = useIsMobile();

  const loadTransactionTypes = async () => {
    const createdAtFrom = getUnixTime(subHours(new Date(), hours));
    await dispatch.account.getTransactionTypeList({
      transactionWallet: activeWallet?.id,
      createdAtFrom
    });
  };

  useEffect(() => {
    !_.isUndefined(activeWallet) && loadTransactionTypes();
  }, [activeWallet, hours]);

  useEffect(() => {
    setType({ code: null, enabled: true, id: null, name: 'All' });
  }, []);

  const handleApply = () => {
    setOpenRange(false);
    onRangeApply();
  };

  const renderPickerWithDrawer = () => {
    return (
      <>
        <Drawer
          className="betting-history__drawer"
          open={ openRange }
          anchor={ 'bottom' }
        >
          <RangePicker
            iconClick={ () => setOpenRange(false) }
            handleApply = { handleApply }
            clear = { onRangeClear }
            dateChange = { dateChanges }
            ranges= { dateRange }
          />
        </Drawer>
        <Backdrop open={ false } />
      </>
    );
  };

  const renderPicker = () => {
    return (
      <div className="range-filter-buttons__filter-container">
        <RangePicker
          iconClick={ () => setOpenRange(false) }
          handleApply = { handleApply }
          clear = { onRangeClear }
          dateChange = { dateChanges }
          ranges= { dateRange }
        />
      </div>
    );
  };

  return (
    <div className="range-filter-buttons">
      <div className="range-filter-buttons__container">
        <button
          className={
            classNames({
              'betting-history__sort': true,
              'betting-history__sort--desc' : false
            })
          }
          onClick={ () => setSort(sort === 'desc' ? 'asc' : 'desc') }
        >
          <Icon className="betting-history__filter" icon={ sort === 'desc' ? 'descending' : 'ascending' } />
          <span className="betting-history__text-label">{ t(`betHistory.${ sort === 'desc' ? 'descending' : 'ascending' }`) }</span>
        </button>
        {
          _.map(filterButtons, button => {
            if (button.value !== 0) {
              return (
                <Button
                  key={ button.value }
                  className={
                    classNames({
                      'btn--outlined': true,
                      'range-filter-buttons__btn': true,
                      'range-filter-buttons__btn--selected': button.value === selectedButton
                    })
                  }
                  name={ button.value.toString() }
                  text={ button.label }
                  onClick={
                    (e) => {
                      onButtonClick(e);
                      setOpenRange(false);
                    }
                  }
                />
              );
            } else {
              return (
                <Button
                  key={ button.value }
                  className={
                    classNames({
                      'btn--outlined': true,
                      'range-filter-buttons__btn': true,
                      'range-filter-buttons__btn--selected': button.value === selectedButton
                    })
                  }
                  name="date"
                  onClick={ () => setOpenRange(!openRange) }
                >
                  <Icon icon="filter" className="range-filter-buttons__icon" />
                  <span className="range-filter-buttons__text">{ t('betHistory.byDate') }</span>
                </Button>
              );
            }
          })
        }
      </div>
      <DropdownTypeList
        dataList={ [{ code: null, enabled: true, id: null, name: 'All' }, ...customerTransactionTypeList] }
        type={ type }
        setType={ setType }
      />
      { openRange && mobile && renderPickerWithDrawer() }
      { openRange && !mobile && renderPicker() }
    </div>
  );
}

export default RangeFilterButtons;
